import { get } from 'svelte/store';
import { user } from './data-store.js';
import { loggedInAs } from './common.js';
import { elementDisplay, elementVisibility, databaseAccess, isUndefined, setText } from './utilities'

async function started() {
    let token
    setupInitialData()
    netlifyIdentity.on('init', async user => {
        if (user) {
            token = user.token.access_token
        }
    })

    netlifyIdentity.on('login', user_obj => {
        if(!user_obj) {
            return
        }
        token = user_obj.token.access_token
        let parsed_token = parseJwt(token)
        let new_user = {}
        new_user.id = parsed_token['sub'];
        new_user.name = parsed_token['user_metadata']['full_name'];
        new_user.email = parsed_token['email'];
        update_user(new_user) ;
        setupUser(new_user.id)
    })

    netlifyIdentity.on('logout', () => {logoutUser()

    })
}

started()

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export async function setupUser(login_id) {
    // Setup a user record for test logins
    if (!login_id) {
        alert('No user id!')
        return
    }
    await getUserRecordByID(login_id);
}

async function getUserRecordByID(login_id) {
    // Creates the user store after reading the db and if not a record asks for username
    let user_store = get(user);
    var user_response = await getUserRecord(login_id, 'users_by_login_id');

    if (user_response.length > 1) {
        alert(`Multiple user records for ${login_id}`);
        return;
    } else if (user_response.length == 0) {
        let user_store = get(user);
        user_store.login_id = login_id;
        user.set(user_store);
        console.log(`No user record for "${login_id}"`);
        elementDisplay('username-popup', 'grid');
        return;
    };

    elementDisplay('main-page', 'grid')
    let user_record = user_response[0].data;
    user_record.key = user_response[0].ref['@ref'].id;
    update_user(user_record);
    displayUserName('visible');
    update_user(user_record);
    if (user_store.username == '') {
        elementDisplay('username-popup', 'grid');
        elementDisplay('main-page', 'none')
    }
    return user_response;
};

function update_user(user_response) {
    let user_store = get(user);
    for (const [key, value] of Object.entries(user_response)) {
        user_store[key] = value;
    }
    user.set(user_store)
}

export async function getUserRecordByUsername(username) {
    // Read the db and if the username exists alert, otherwise create the record
    var user_response = await getUserRecord(username, 'users_by_username');
    if (user_response.length > 0) {
        alert(`The username "${username}" is already taken. Please select another.`)
        elementDisplay('username-popup', 'grid')
        return 'already-exists';
    };
    let user_store = get(user);
    if (user_store.login_id) {
        user_response = await getUserRecordByID(user_store.login_id);
        if (user_response) {
            return;
        }
    }
    if (typeof user_response == 'undefined' || user_response.length == 0) {
        createUserRecord(username)
    }
    return ''
};

export async function logoutUser() {
    displayUserName('hidden');
    setupInitialData()
    console.log('logout')
    elementDisplay('main-page', 'none')
};

async function getUserRecord(key, index_name) {
    // Read the db and return the response
    let db_params = {
        collection_name: 'users',
        access_type: 'select-records',
        index: index_name,
        key: key,
    }
    var db_response = await databaseAccess(db_params);
    var user_response = await db_response.json();
    return user_response;
};

async function createUserRecord(username) {
    // Create the user record on the db
    let user_store = get(user)
    user_store.username = username
    user.set(user_store)

    let db_params = {
        collection_name: 'users',
        access_type: 'create',
        record: user_store,
    }
    await databaseAccess(db_params);
    elementDisplay('username-popup', 'none') ;
    displayUserName('visible');
    return user;
}

function displayUserName(visibility) {
    let user_store = get(user)
    user_store = setupInitialData()
    setText('login-as-text', loggedInAs(user_store.username));
    setText('login-as-text-dummy', loggedInAs(user_store.username));
    elementVisibility('login-as-text', visibility);
};

export function setupInitialData() {
    let user_store = get(user);
    var greeting_data = getDataAndDefault(user_store.greetings);
    user_store.greeting_list = greeting_data.list;
    user_store.default_greeting = greeting_data.default;
    user_store.selected_greeting = greeting_data.default;

    var valediction_data = getDataAndDefault(user_store.valedictions);
    user_store.valediction_list = valediction_data.list;
    user_store.default_valediction = valediction_data.default;
    user_store.selected_valediction = valediction_data.default;
    user.set(user_store)
    return user_store;
}

function getDataAndDefault(source) {
    var list = [];
    var default_item = '';
    if (!isUndefined(source)) {
        for (let item of source) {
            list.push(item[0]);
            if (item[1] == 'D') {
                default_item = item[0];
            }
        }
        if (default_item == '') {
            default_item = list[0]
        }
    };
    return {
        list: list.sort(),
        default: default_item
    };
}

export async  function writeToUser() {
    // let user_record = get(user)
    let user_record = JSON.parse(JSON.stringify(get(user))); // deep copy
    user_record.greetings = buildMessageList(user_record.greeting_list, user_record.default_greeting)
    user_record.valedictions = buildMessageList(user_record.valediction_list, user_record.default_valediction)
    let removals = [
        'key',
        'greeting_list',
        'valediction_list',
        'default_greeting',
        'default_valediction',
        'selected_greeting',
        'selected_valediction'
    ]
    let temp_user = {};
    for (let item of removals) {
        temp_user[item] = user_record[item]
        delete user_record[item]
    }

    for (let item of removals) {
        user_record[item] = temp_user[item]
    }
    let db_params = {
        collection_name: 'users',
        access_type: 'update',
        record: user_record,
        key: user_record.key,
    };
    await databaseAccess(db_params);
}

function buildMessageList(messages, default_item) {
    var message_list = []
    for (let message of messages) {
        let message_obj = [message]
        if (message== default_item) {
            message_obj.push('D')
        }
        message_list.push(message_obj)
    }
    return message_list
}